export default __webpack_public_path__ + "static/media/profile.539737bb.jpeg";